/**
 * Site type constants for multi-tenant routing and configuration.
 * These determine the routing structure and available pages for each site.
 */

/** News/Blog style site with full navigation and /football/ prefix */
export const SITE_TYPE_NEWS_BLOG = "news-blog" as const;

/** Competition-focused site with simplified navigation */
export const SITE_TYPE_FOOTBALL_COMPETITION = "football-competition-site" as const;

/** General-purpose site with article and editorial content, no sport-specific routes */
export const SITE_TYPE_BASIC = "basic" as const;

/** Team-focused site (single football club) with team-implicit URLs */
export const SITE_TYPE_FOOTBALL_TEAM = "football-team-site" as const;

/**
 * All available site types as a union type.
 * This type is derived from the constants for type safety.
 */
export type SiteType =
    | typeof SITE_TYPE_NEWS_BLOG
    | typeof SITE_TYPE_FOOTBALL_COMPETITION
    | typeof SITE_TYPE_BASIC
    | typeof SITE_TYPE_FOOTBALL_TEAM;

/**
 * Array of all site types for iteration and validation.
 */
export const ALL_SITE_TYPES = [
    SITE_TYPE_NEWS_BLOG,
    SITE_TYPE_FOOTBALL_COMPETITION,
    SITE_TYPE_BASIC,
    SITE_TYPE_FOOTBALL_TEAM,
] as const;

/**
 * Site type options for Payload CMS select fields.
 */
export const SITE_TYPE_OPTIONS = [
    { label: "News Blog", value: SITE_TYPE_NEWS_BLOG },
    { label: "Football Competition Site", value: SITE_TYPE_FOOTBALL_COMPETITION },
    { label: "Basic", value: SITE_TYPE_BASIC },
    { label: "Football Team Site", value: SITE_TYPE_FOOTBALL_TEAM },
] as const;

/**
 * Default site type to use when not specified.
 */
export const DEFAULT_SITE_TYPE = SITE_TYPE_NEWS_BLOG;
